import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { DynamicPicture } from 'common/components';
import { printWithNBSP } from 'utils';
import { selectIsSmallScreen } from 'store/pageStore';
import { advantagesImgSizes } from 'data';
import { TAdvantagesCardData } from '../../types';
import { CardRemark } from '../card-remark';

import {
	Card,
	headerStyles,
	HeaderWrapper,
	imgStyles,
	ListItemText,
	StyledList,
	StyledListItem,
} from './styles';

type AdvantagesCardProps = {
	data: TAdvantagesCardData;
};

export const AdvantagesCard = ({ data }: AdvantagesCardProps) => {
	const { header, isHeaderShort, remark, photoUrl, listItems } = data;
	const isSmallScreen = useSelector(selectIsSmallScreen);

	return (
		<Card data-qa="advantages-card" className="advantages-card">
			<DynamicPicture imgCN={imgStyles} baseUrl={photoUrl} sizes={advantagesImgSizes} />
			<div>
				<HeaderWrapper isShort={isHeaderShort}>
					<Typography className={headerStyles} variant="h3" as="p" overrideStyles={false}>
						{printWithNBSP(header)}
					</Typography>
				</HeaderWrapper>
				<StyledList>
					{listItems.map((item, index) => (
						<StyledListItem
							key={`advantages-card/item-${index}`}
							data-qa="advantages-card__list-item"
						>
							<Typography
								variant={isSmallScreen ? 's' : 'm'}
								size="body_short"
								className={ListItemText}
								as="p"
								overrideStyles={false}
							>
								{printWithNBSP(item)}
							</Typography>
						</StyledListItem>
					))}
				</StyledList>
				{remark && <CardRemark />}
			</div>
		</Card>
	);
};
